import React from "react";
import { useNavigate } from "react-router-dom";
import {
  FaTelegram,
  FaFileAlt,
  FaLinkedin,
  FaInstagramSquare
} from "react-icons/fa";
import { CiMail } from "react-icons/ci";
import { FaXTwitter } from "react-icons/fa6";
import Logo from "../../../images/logo.png";

const Footer = () => {
  const navigate = useNavigate();
  return (
    <footer className="bg-black text-white p-4">
      <div className="max-w-7xl mx-auto flex flex-col gap-6 lg:flex-row justify-between items-center">
        <div className="logo-wrapper">
          <div className="flex items-center mb-2 pl-2">
            <img
              onClick={() => navigate("/")}
              src={Logo}
              alt="BAF Logo"
              className="w-[8rem] h-auto"
            />
          </div>
        </div>

        <div className="flex flex-col gap-4">
          <div className="text-white w-full text-center flex justify-center items-center gap-2 hover:text-yellowbuy">
            <CiMail className="w-6 h-6" />
            <a
              href="mailto:info@baf.com"
              className="text-white hover:text-yellow-400 text-base"
            >
              info@baf.com
            </a>
          </div>

          <p className="m-0 text-center text-[#FFFFFFB0] text-base">
            © Copyright BAF | BAF Token - All Rights Reserved.
          </p>
          <div className="text-white w-full text-center flex justify-center items-center gap-2 hover:text-yellowbuy">
            <a
              href="/terms-and-conditions"
              target="_blank"
              className="text-white hover:text-yellow-400 text-base"
            >
              Privacy Policy
            </a>
          </div>
        </div>

        {/* Right Section: Social Media Icons */}
        <div className="flex gap-4">
          <a
            href="https://x.com/baf_token"
            target="_blank"
            rel="noopener noreferrer"
            className="text-gray-300 hover:text-yellow-400"
          >
            <div className="bg-white p-2 rounded-full text-black">
              <FaXTwitter className="w-6 h-6" />
            </div>
          </a>
          <a
            href=" https://www.instagram.com/nft-bafdemo/"
            target="_blank"
            rel="noopener noreferrer"
            className="text-gray-300 hover:text-yellow-400"
          >
            <div className="bg-white p-2 rounded-full text-black">
              <FaInstagramSquare className="w-6 h-6" />
            </div>
          </a>
          <a
            href="https://t.me/Publicmemetoken_GroupChat"
            target="_blank"
            rel="noopener noreferrer"
            className="text-gray-300 hover:text-yellow-400"
          >
            <div className="bg-white p-2 rounded-full text-black">
              <FaTelegram className="w-6 h-6" />
            </div>
          </a>
          <a
            href="https://www.linkedin.com/company/nft-bafdemo/"
            target="_blank"
            rel="noopener noreferrer"
            className="text-gray-300 hover:text-yellow-400"
          >
            <div className="bg-white p-2 rounded-full text-black">
              <FaLinkedin className="w-6 h-6" />
            </div>
          </a>

          <a
            href="https://docs.baf.com/nft-bafdemo-token-docs"
            target="_blank"
            rel="noopener noreferrer"
            className="text-gray-300 hover:text-yellow-400"
          >
            <div className="bg-white p-2 rounded-full text-black">
              <FaFileAlt className="w-6 h-6" />
            </div>
          </a>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
